import { DOCUMENT_ORIGIN } from './consts'

export const post = async (url, data) => {
  let formData = new FormData()
  formData.append('type', 'user')

  Object.keys(data).forEach((key) => formData.append(key, data[key]))

  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  })

  try {
    const contentType = response.headers.get('content-type')

    if (
      contentType &&
      (contentType.includes('application/json') ||
        contentType.includes('text/json'))
    ) {
      return await response.json()
    } else {
      console.error('Received non-JSON response:', contentType)
      return { error: `Server returned non-JSON response ${contentType}` }
    }
  } catch (error) {
    console.error('Request failed:', error)
    return { error: error.message || 'Unknown error occurred' }
  }
}

export const get = async (url, token) => {
  const response = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })

  try {
    if (!response.ok) {
      console.error('Request failed with status:', response.status)

      return { error: `Request failed with status: ${response.status}` }
    }

    const contentType = response.headers.get('content-type')
    if (
      contentType &&
      (contentType.includes('application/json') ||
        contentType.includes('text/json'))
    ) {
      return await response.json()
    } else {
      console.error('Received non-JSON response:', contentType)

      return { error: 'Server returned non-JSON response' }
    }
  } catch (error) {
    console.error('Request failed:', error)

    return { error: error.message || 'Unknown error occurred' }
  }
}

export const obtainToken = async () => {
  const envAuthToken = import.meta.env.VITE_AUTH_TOKEN

  if (envAuthToken) {
    return { auth_token: envAuthToken }
  }

  const url = `${DOCUMENT_ORIGIN}/rpc/token?method=obtain_auth_token`
  const response = await fetch(url, { credentials: 'include' })

  if (!response.ok) return null

  try {
    const contentType = response.headers.get('content-type')
    if (
      contentType &&
      (contentType.includes('application/json') ||
        contentType.includes('text/json'))
    ) {
      return await response.json()
    } else {
      console.error('Received non-JSON response:', contentType)

      return null
    }
  } catch (error) {
    console.error('Failed to parse token response:', error)

    return null
  }
}

export const bindUserSession = async (token) => {
  const url = `${DOCUMENT_ORIGIN}/rpc/token?method=bind_session_token&auth_token=${token}`

  try {
    const response = await fetch(url, { credentials: 'include' })

    if (!response.ok) {
      console.error(
        'Failed to bind user session with status:',
        response.statusText
      )
      return false
    }

    const contentType = response.headers.get('content-type')
    if (
      contentType &&
      (contentType.includes('application/json') ||
        contentType.includes('text/json'))
    ) {
      return await response.json()
    } else {
      console.error('Received non-JSON response:', contentType)

      return false
    }
  } catch (error) {
    console.error('Failed to bind user session:', error)

    return false
  }
}
